import SidebarLayout from "components/Layout/Layout";
import { useTheme } from "components/provider/theme";
import { API_URL } from "env";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import type { PopconfirmProps } from 'antd/es/popconfirm';
import { Button, message, Popconfirm } from 'antd';

const EventPage = () => {
    const { theme } = useTheme();
    const [events, setEvents] = useState<{
        id: number;
        title?: {
            en: string;
            vi: string;
        };
        subtitle?: {
            en: string;
            vi: string;
        };
        description?: string;
        type?: string;
        active?: boolean;
    }[]>([]);


    async function fetchEvents() {
        try {
            const response = await fetch(`${API_URL}api/v1/be/events`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            const data = await response.json();
            if (data.status) {
                setEvents(data.data.items);
            } else {
                alert(data.message || 'Failed to fetch events');
            }
        }
        catch (error) {
            console.error('Error fetching events:', error);
        }
    }

    async function toggleEventStatus(eventId: number, currentStatus: boolean) {
        try {
            const response = await fetch(`${API_URL}api/v1/be/events/${eventId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    active: !currentStatus,
                })
            });
            const data = await response.json();
            if (data.status) {
                toast.success(`Event status updated successfully`);
                fetchEvents();
            } else {
                toast.error(data.message || 'Failed to update event status');
            }
        }
        catch (error) {
            toast.error('Error updating event status');
        }
    }

    async function deleteEvent(eventId: number) {
        try {
            const response = await fetch(`${API_URL}api/v1/be/events/${eventId}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            const data = await response.json();
            if (data.status) {
                toast.success('Event deleted successfully');
                fetchEvents();
            } else {
                toast.error(data.message || 'Failed to delete event');
            }
        }
        catch (error) {
            toast.error('Error deleting event');
        }
    }

    useEffect(() => {
        fetchEvents();
    }, []);

    return <SidebarLayout
        title={(
            <h4 className={`text-2xl font-bold !m-0 ${theme === "light" ? 'text-gray-800' : ''} py-4`}>
                Event Dashboard
            </h4>
        )}
    >
        <div className="w-full ">
            <div className={`rounded-lg shadow-sm ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} p-4`}>
                <div className="mb-6 flex justify-between items-center">
                    <h2 className="text-xl font-semibold mb-4">Events List</h2>
                    <div className="flex !space-x-2">
                        <button
                            onClick={() => window.location.href = '/events/create'}
                            className="px-4 py-2 bg-blue-600 !text-white rounded hover:bg-blue-700"
                        >
                            Create Event
                        </button>
                        <button
                            onClick={() => window.location.reload()}
                            className="px-4 py-2 bg-gray-600 !text-white rounded hover:bg-gray-700"
                        >
                            Refresh
                        </button>
                    </div>
                </div>
                <div className="space-y-4">
                    <table className="min-w-full border border-gray-200">
                        <thead>
                            <tr className="border-b">
                                <th className="text-left p-2 w-1/12">ID</th>
                                <th className="text-left p-2 w-3/12">Title EN</th>
                                <th className="text-left p-2 w-3/12">Title VI</th>
                                <th className="text-left p-2 w-1/12">Type</th>
                                <th className="text-left p-2 w-2/12">Status</th>
                                <th className="text-left p-2 w-2/12">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {events.map(event => (
                                <tr key={event.id} className="hover:bg-gray-100 hover:text-black" onClick={() => window.location.href = `/events/${event.id}`}>
                                    <td className="p-2">{event.id}</td>
                                    <td className="p-2">{event.title?.en || ''}</td>
                                    <td className="p-2">{event.title?.vi || ''}</td>
                                    <td className="p-2">{event.type}</td>
                                    <td className="p-2">{event.active ? 'Active' : 'Inactive'}</td>
                                    <td className="p-2 flex !space-x-2 w-fit">
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                window.location.href = `/events/${event.id}`;
                                            }}
                                            className="px-2 py-1 bg-green-600 !text-white rounded hover:bg-green-700 mr-2"
                                        >
                                            View
                                        </button>
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                toggleEventStatus(event.id, event.active || false);
                                            }}
                                            className={`px-2 py-1 !text-white rounded hover:bg-yellow-700 bg-yellow-600`}
                                        >
                                            {event.active ? 'Inactive' : 'Active'} this event
                                        </button>
                                        <Popconfirm
                                            title="Delete the task"
                                            description="Are you sure to delete this task?"
                                            onConfirm={
                                                (e) => {
                                                    e?.stopPropagation();
                                                    deleteEvent(event.id);
                                                }
                                            }
                                            onCancel={(e) => { }}
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <button 
                                                className = "px-2 py-1 bg-red-600 !text-white rounded hover:bg-red-700"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                }}
                                            >
                                                Delete
                                            </button>
                                        </Popconfirm>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </SidebarLayout>;
}

export default EventPage;